import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import SettingsIcon from '@material-ui/icons/Settings'

import { AppBar, makeStyles, Toolbar } from '@material-ui/core'
import InstrumentAutocomplete from './InstrumentsAutocomplete'

import SmartIconButton from './SmartIconButton'
import SettingsModal from './SettingsModal'
import SmartNavLinks from './SmartNavLinks'

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    // flexGrow: 1,
  },
  routes: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 24
  },
  iconButtonSettings: {
    marginLeft: 12,
    // color: 'darkgrey',
    width: 72,
    height: 72
  },
  iconSettings: {
    fontSize: 32
  }
}))

const navLinks = [{
	title: 'Chord Finder',
	to: '/chord-finder',
}, {
	title: 'Scale Visualizer',
	to: '/scale-visualizer'
// }, {
// 	title: 'Walking Bass Generator',
// 	to: '/walking-bass-generator'
}, {
	title: 'Tiny DAW',
	to: '/tiny-daw'
// }, {
// 	title: 'Chord Progression Generator',
// 	to: '/chord-progression-generator'
}, {
	title: 'Backing Track Generator',
	to: '/backing-track-generator'
}]

function MyAppBar(props: {
	settings: any,
	onSettingsChange: (settings: any) => void,
	constants: any
}) {

	const {
		settings,
		constants,
		onSettingsChange
	} = props

  const classes = useStyles()
  
  const [settingsOpen, setSettingsOpen] = useState(false)

	const location = useLocation()

	useEffect(() => {

		console.log({ location })

		document.body.id = location.pathname.slice(1) + '-body'
		
  }, [location])

	{/* <AppBar position="static" style={{ marginBottom: 64 }} elevation={8} id="app-bar" > */}
  return (
		<React.Fragment>
			<AppBar position="static" style={{ marginBottom: 64, backgroundColor: 'transparent', paddingTop: 24 }} elevation={0} id="app-bar" >
				<Toolbar>
					
					<div style={{ display: 'flex', minWidth: '20%' }}>
						
					</div>
					{/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
						<MenuIcon />
					</IconButton> */}
					{/* <Typography variant="h4" component="h1" className={classes.title}>
						{title}
					</Typography> */}
					<div className={classes.routes}>
						<SmartNavLinks
							navLinks={navLinks}
						/>
					</div>
					{useLocation().pathname !== '/tiny-daw' ? (
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', minWidth: '20%', height: 88 }}>
							<InstrumentAutocomplete
								instruments={constants.instruments}
								instrument={settings.instrument}
								onInstrumentChange={(instrument) => onSettingsChange({ ...settings, instrument })}
							/>
							{/* TODO: s again to close settings */}
							<SmartIconButton keyName='s' onClick={() => setSettingsOpen(true)} className={classes.iconButtonSettings} aria-label="play audio">
								<SettingsIcon className={classes.iconSettings} />
							</SmartIconButton>
						</div>
					) :  <div style={{ minWidth: '20%', height: 88 }}></div>}
				</Toolbar>
			</AppBar>
			
			<SettingsModal
				open={settingsOpen}
				onClose={() => setSettingsOpen(false)}
				settings={settings}
				onSettingsChange={onSettingsChange}
				tunings={constants.tunings}
				instruments={constants.instruments}
				sounds={constants.sounds}
			/>

		</React.Fragment>
  )
}

export default MyAppBar

// TODO : Code a vscode extension to extract component